import { Navigate, useSearchParams } from "react-router-dom";

/**
 * Signup is the same WhatsApp phone flow as login. New numbers finish name +
 * username on /onboarding after OTP (matches mobile).
 */
export function SignUpPage() {
  const [params] = useSearchParams();
  const next = params.get("next");
  const to = next ? `/login?next=${encodeURIComponent(next)}` : "/login";
  return <Navigate to={to} replace />;
}
